import React, { useState } from 'react'

export default function TextForm(props) {

    const handleUpperCaseClick = () => {
        let newText = text.toUpperCase();
        setText(newText);
        props.showAlert("Converted to uppercase", "success");
    }
    const handleLowerCaseClick = () => {
        let newText = text.toLowerCase();
        setText(newText);
        props.showAlert("Converted to lowercase", "success");
    }
    const handleCapClick = () => {
        let newText = text.split(" ").map(ele =>
            ele.charAt(0).toUpperCase() + ele.slice(1)).join(" ");
        setText(newText);
        props.showAlert("Capitalised", "success");
    }
    const handleExtraSpaces = () => {
        let newText = text.split(/[ ]+/);
        setText(newText.join(" "));
        props.showAlert("Extra spaces removed", "success");
    }
    const handleCopyClick = () => {
        let text = document.getElementById('myBox').value;
        // text.select();
        navigator.clipboard.writeText(text);
        props.showAlert("Copied to clipboard", "success");
    }
    const handleClearClick = () => {
        let newText = '';
        setText(newText);
        props.showAlert("Text cleared", "success");
    }

    const handleOnChange = (event) => {
        setText(event.target.value);
    }

    const [text, setText] = useState('Enter text here');
    return (
        <>
            <div className="container " style={{ color: props.mode === "light" ? "#042743" : "white" }}>
                <h2>{props.heading}</h2>
                <div className="mb-3">
                    <textarea className="form-control" id="myBox" rows="6" style={{ backgroundColor: props.mode === "light" ? "white" : "grey", color: props.mode === "light" ? "#042743" : "white" }} value={text} onChange={handleOnChange} aria-label="With textarea"></textarea>
                </div>
                <button className="btn btn-primary mx-1" onClick={handleUpperCaseClick}>Convert to uppercase</button>
                <button className="btn btn-primary mx-1" onClick={handleLowerCaseClick}>Convert to lowercase</button>
                <button className="btn btn-primary mx-1" onClick={handleCapClick}>Capitalise</button>
                <button className="btn btn-primary mx-1" onClick={handleExtraSpaces}>Remove Extra Spaces</button>
                <button className="btn btn-primary mx-1" onClick={handleCopyClick}>Copy Text</button>
                <button className="btn btn-primary mx-1" onClick={handleClearClick}>Clear Text</button>
            </div>
            <div className="container my-3" style={{ color: props.mode === "light" ? "#042743" : "white" }} >
                <h3>Your text summary</h3>
                <p>{text.split(" ").length} words, {text.length} characters, {text.split("\n").length} paragraphs</p>
                <p>{0.008 * text.split(" ").length} mintues read</p>
                <h4>Preview</h4>
                <p>{text.length > 0 ? text : "Enter something in the textbox above to preview it. "}</p>
            </div>
        </>
    )
}
